import { ProjectColorMenuContent } from '@components/ArtBoard/ArtboardToolbar'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useProjectAccess } from '@/hooks'
import { PROJECT_SETTINGS_PERMISSION } from '@/permissions/project/definitions'

// The color menu of a tag row: the same grid as the page color menu.
export const TagColorMenu: React.FC = () => {
  const colors = useSelector(migrationProjectSelector.getProjectColors)
  const { hasNotAvailableAccessBadge: locked } = useProjectAccess(
    PROJECT_SETTINGS_PERMISSION.COLOR_LIBRARY_TAB
  )

  // A tag has no color to inherit, unlike a page from its parent.
  return (
    <ProjectColorMenuContent colors={colors} inheritLabel="" locked={locked} />
  )
}
